<template>
  <div class="weui-cells weui-cells_form">
    <h3 class="page__title">车牌上报关怀页面</h3>

   <!--

    <div class="weui-cell weui-cell_active weui-cell_vcode">
        <div class="weui-cell__hd">
            <label class="weui-label">网点消息</label>
        </div>
        <div class="weui-cell__bd weui-cell__bd-WU">
            <input class="weui-input" style="text-align:center" type="text" placeholder="填写发送给用户的模板消息文本：如欢迎光临众敏洗车链" v-model="msg_text"/>
        </div>
    </div>
    <div class="weui-cell weui-cell_active weui-cell_vcode">
        <div class="weui-cell__hd">
            <label class="weui-label">网点链接</label>
        </div>
        <div class="weui-cell__bd weui-cell__bd-WU">
            <input class="weui-input" style="text-align:center" type="text" placeholder="填写发送给用户的模板消息点击后跳转的URL：默认为店面详情页" v-model="msg_url"/>
        </div>
    </div>
    <div class="weui-cell weui-cell_active weui-cell_vcode">
        <div class="weui-cell__hd">
            <label class="weui-label">替换门店名</label>
        </div>
        <div class="weui-cell__bd weui-cell__bd-WU">
            <input class="weui-input" style="text-align:center" type="text" placeholder="" v-model="msgPayLoad.url"/>
        </div>
    </div>  -->
    <div class="weui-cell weui-cell_active weui-cell_vcode">
        <div class="weui-cell__hd">
            <label class="weui-label">链点消息</label>
        </div>
        <div class="weui-cell__bd weui-cell__bd-WU">
            <input class="weui-input" style="text-align:center" type="text" placeholder="填写发送给用户的模板消息文本：如欢迎光临众敏洗车链" v-model="ld_msg_text"/>
        </div>
    </div>
    <div class="weui-cell weui-cell_active weui-cell_vcode">
        <div class="weui-cell__hd">
            <label class="weui-label">链点链接</label>
        </div>
        <div class="weui-cell__bd weui-cell__bd-WU">
            <input class="weui-input" style="text-align:center" type="text" placeholder="填写发送给用户的模板消息点击后跳转的URL：默认为店面详情页" v-model="ld_msg_url"/>
        </div>
    </div>
    <div class="weui-cell weui-cell_active weui-cell_vcode">
        <div class="weui-cell__hd">
            <label class="weui-label">模拟车牌</label>
        </div>
        <div class="weui-cell__bd weui-cell__bd-WU">
            <input class="weui-input" style="text-align:center" type="text" placeholder="填写车牌，用来模拟车牌进入" v-model="msgPayLoad.plate"/>
        </div>
    </div>                    
    <div class="weui-cell weui-cell_active weui-cell_vcode">
        <div class="weui-cell__hd">
            <label class="weui-label">模拟门店</label> 
        </div>
        <div class="weui-cell__bd weui-cell__bd-WU">
            <input class="weui-input" style="text-align:center" type="text" placeholder="填写控制器ID，用来模拟进入门店" v-model="msgPayLoad.controllerID"/>
        </div>
    </div>          

    <div class="weui-cell weui-cell_active weui-cell_vcode">
        <div class="weui-cell__hd">
            <label class="weui-label">是否自动发</label>
        </div>
        <div class="weui-cell__bd weui-cell__bd-WU">
            <input type="checkbox"  v-model="autosendSMS" />短信门店
            <input type="checkbox"  v-model="autosend" />模板门店
            <input type="checkbox"  v-model="autosendLD" />模板链点
        </div>
    </div>
    <div class="weui-cell weui-cell_active weui-cell_vcode">
        <div class="weui-cell__hd">
        </div>
        <div class="weui-cell__bd weui-cell__bd-WU">
          <a @click="startWork" class="weui-btn weui-btn_primary">开始工作</a>
          <a style="color:blue" @click="testPlateIn"  >测试车牌到店</a> |
          <a style="color:blue" @click="toUrl('operation_msg')"  >手工营销</a>
        </div>


    </div>
    <div class="weui-msg">
      <textarea style="width:100%;height: 100px;" v-model="last_message"></textarea>
    </div>
    <div class="weui-msg" v-if="plateList.length > 0">
      <table class="table table-striped " style="font-size: small;">
        <thead><!--
        <td>车牌</td>
        <td>网点</td>-->

        <td>ID</td>
        <td>时间</td>
        <td>车牌</td>
        <td>网点</td>
        </thead>
        <tbody  v-for="itm in plateList" :key="itm.id">
        <tr><!--
          <td>{{itm.plate}}</td>
          <td>{{itm.storeName}}</td>-->
          <td>{{itm.id}}</td>
          <td>{{ itm.tm }}</td>
          <td>{{itm.plate}}</td>
          <td>{{itm.storeName}}</td>
        </tr>
        <tr v-for="(user,idx) in itm.userAccount" :key="(itm.id + user)" >
          <td>{{ itm.nickname[idx] }} {{ itm.mobile[idx]  }}</td>
          <td colspan="2">
            <span>
              <a style="color: blue;" @click="sendMsg(itm,idx,false)" >模板到店</a> <br/>
              <a style="color: blue;" @click="sendMsgOfLD(itm,idx,false)">模板链点</a><br/>
              <a style="color: blue;" @click="sendMsgOfSMS(itm,idx,false)" v-if="itm.mobile[idx] != null">短信门店</a>
            </span>
          </td>
          <td><span  >{{itm.state[idx][0]}} <br/>{{itm.state[idx][1]}}<br/> {{itm.state[idx][2]}} </span></td>
        </tr>
        <tr v-for="(mobile,idx) in itm.mobile" :key="(itm.id + mobile)" v-show="itm.userAccount.length == 0" >
          <td>{{ mobile }}</td>
          <td colspan="2">
            <span>
              <a style="color: blue;" @click="sendMsgOfSMS(itm,idx,false)" >发送短信门店</a>
            </span>
          </td>
          <td><span  >{{itm.state[idx][2]}} </span></td>
        </tr>
        </tbody>
        <tfoot>

        </tfoot>
      </table>

    </div>
    <div class="weui-msg" v-else>
      <div class="weui-msg__icon-area"><i class="weui-icon-warn weui-icon_msg"></i></div>
      <div class="weui-msg__text-area">
          <h2 class="weui-msg__title">还没有收到上报的车牌</h2>
      </div>
    </div>
    <div id="loadingToast" style="display: none;" v-if="ing">
      <div class="weui-mask_transparent"></div>
      <div class="weui-toast">
          <span class="weui-primary-loading weui-primary-loading_transparent weui-icon_toast">
            <span class="weui-primary-loading__dot"></span>
          </span>
          <p class="weui-toast__content">加载中</p>
      </div>
  </div>
  <div role="alert" class="weui-toptips weui-toptips_warn" id="warnToast">{{this.errMsg}}</div>
  </div>
</template>

<script>

import axios from "axios"
import JQ from 'jquery'

import mqtt from 'mqtt'

var mqttClient = null

const mqttUrl = "wss://mqtt.nationaiot.com/mqtt"

const mqttOptions = {

connectTimeout:3000,
clientId:'omc-plate-report-msg',
username:'ccnet',
password:'ccnet0901',
clean:false,
}

const mqttTopic = "ccnet/up/#"



function get2Str(str){
return padding1(str,2);
}

function padding1(num, length) {
  for(var len = (num + "").length; len < length; len = num.length) {
 num = "0" + num;
}
return num;
}
export default {
data () {
  return {
    ing:true,
    errMsg:"获取数据失败",
    userAccount:"",
    nickname:"",
    mobile:"",
    plate:"",
    date:new Date(),
    userList : [],
    plateList:[],
    autosend:true,
    autosendSMS:false,
    autosendLD:false,
    msg_url:"",
    msg_text:"欢迎【PLATE】来到众敏加盟门店【POSNAME】，请点击这里开始服务。",
    last_message:"还没有收到任何消息",
    ld_msg_url:"https://zmxcl.nationaiot.com/customer/awardQRCode?awardId=57",
    ld_msg_text:"有链点可领取，链点可用来到所有网点支付服务费。",
    sendFlag:true,
    msgInterval:0,
    msgPayLoad:{"autoWasher":"0",
      "controllerID":"866651068078180","deviceID":"1","msgID":"95510","msgType":"report",
      "plate":"粤B021RY",
      "sign":"0f7000df3bbd8686ad2e822e01af51be6271c00e","state":"100","timestamp":"1681222462","ver":"1","url":""}


  }
},
mounted() {
     this.startWork();

},
destroyed(){
  this.stopWork()
},
methods: {
 stopWork(){
  if(mqttClient){
    mqttClient.end();
    mqttClient = null;
  }
 },
 startWork(){

  let that = this;
  this.stopWork();
  if(!mqttClient){
    mqttClient = mqtt.connect(mqttUrl,mqttOptions)
  }
  // connect
  mqttClient.on('connect',(e) => {
    console.log("连接成功")
    mqttClient.subscribe(mqttTopic,{qos:2},(err) =>{
      if(!err){
        console.log("消息订阅成功")
      }else{
        console.log("消息订阅失败")
      }
    })
  })
  //
  mqttClient.on('message',(topic,msg) => {
    //console.log("收到来自",topic,"的消息:",msg.toString())
    try{
      that.parseMessage(msg.toString());
    }catch(exp){
      console.log(exp)
    }
  })

 },
 testPlateIn(){

  console.log("testPlateIn",this.msgPayLoad)
  
  mqttClient.publish('ccnet/up/'+this.msgPayLoad.controllerID, JSON.stringify(this.msgPayLoad), 2, error => {

    if (error) {
      console.log('Publish error', error)
    }
  })
 },
 parseMessage(msg){

  if(this.last_message == msg) return;






  // 解析消息，并记录到表格
  let msgJson = JSON.parse(msg);

  if(msgJson.state != "100") return;

  this.last_message = msg;
  this.msgInterval++

  this.reportPlate()


  /*
  {"autoWasher":"0","controllerID":"abc","deviceID":"1","msgID":"95510","msgType":"report","plate":"粤B021RY","sign":"0f7000df3bbd8686ad2e822e01af51be6271c00e","state":"100","timestamp":"1681222462","ver":"1"}
  */

  //if((msgJson.controllerID == "866651068097081" ) && (msgJson.state == "100")){
  //  msgJson.plate = "粤B021RY";
  // }
  if((msgJson.plate != undefined)&& (msgJson.state == "100")){

    this.msgInterval = 0

    console.log(msg)

        let plateMsg ={}

        plateMsg.plate = msgJson.plate;
        plateMsg.storeId = msgJson.controllerID
        plateMsg.storeName = this.getStoreName(msgJson.controllerID)
        plateMsg.id =  this.plateList.length + "_" + msgJson.msgID ;
        plateMsg.userAccount = [];
        plateMsg.msgText = this.msg_text.replace("POSNAME",this.getStoreName(msgJson.controllerID)).replace("PLATE",msgJson.plate);
        plateMsg.msgUrl = this.getStoreUrl(msgJson.controllerID);
        plateMsg.state = [["","",""]];
        plateMsg.nickname = [];
        plateMsg.mobile = [];
        plateMsg.tm = msgJson.timestamp;
        plateMsg.reported = false;

        //this.plateList2.push(plateMsg);
        // this.plateList2.sort(function(a,b){return a.id > b.id})
        this.plateList.splice(0,0,plateMsg);

        console.log(plateMsg)



    this.getPlateList(plateMsg)

    // this.getPlateList(msgJson.msgID,msgJson.controllerID,msgJson.plate)
  }
},
 toUrl(target){
    this.$router.push({name:target,params:{
    }});
  },

  getStoreUrl(sid){
    let sName = "https://zmxcl.nationaiot.com/customer/wellcomeJump?state=1";
      if(sid =="866651068097081") sName =      "https://zmxcl.nationaiot.com/customer/wellcomeJump?state=27&posID=P2023040300073";// P202208020059
      else if(sid =="865771054650213") sName = "https://zmxcl.nationaiot.com/customer/wellcomeJump?state=27&posID=P2023040300075";
      else if(sid =="866651068078180") sName = "https://zmxcl.nationaiot.com/customer/wellcomeJump?state=27&posID=P2023040300074";
      else if(sid =="866651068078883") sName = "https://zmxcl.nationaiot.com/customer/wellcomeJump?state=27&posID=P2023040300071";
      else if(sid =="866651069425752") sName = "https://zmxcl.nationaiot.com/customer/wellcomeJump?state=27&posID=P2023040300076";
      else if(sid =="865771054653191") sName = "https://zmxcl.nationaiot.com/customer/wellcomeJump?state=27&posID=P2023040300072";
      else if(sid =="866651067293376") sName = "https://zmxcl.nationaiot.com/customer/wellcomeJump?state=27&posID=P2023040300078";
      else if(sid =="865771054653167") sName = "https://zmxcl.nationaiot.com/customer/wellcomeJump?state=27&posID=P2023040300077";
      else if(sid =="865771054654215") sName = "https://zmxcl.nationaiot.com/customer/wellcomeJump?state=27&posID=P2023040300070";
    return sName;
  },

  getStoreID(sid){
    let sName = sid;
      if(sid =="866651068097081") sName =      "P2023040300073";// P202208020059
      else if(sid =="865771054650213") sName = "P2023040300075";
      else if(sid =="866651068078180") sName = "P2023040300074";
      else if(sid =="866651068078883") sName = "P2023040300071";
      else if(sid =="866651069425752") sName = "P2023040300076";
      else if(sid =="865771054653191") sName = "P2023040300072";
      else if(sid =="866651067293376") sName = "P2023040300078";
      else if(sid =="865771054653167") sName = "P2023040300077";
      else if(sid =="865771054654215") sName = "P2023040300070";
    return sName;
  },
  

  getStoreName(sid){
    let sName = sid;
      if(sid =="866651068097081") sName = "欧洲城";
      else if(sid =="865771054650213") sName = "科技园2号机";
      else if(sid =="866651068078180") sName = "科技园1号机";
      else if(sid =="866651068078883") sName = "台山碧桂园花地";
      else if(sid =="866651069425752") sName = "鹤山碧桂园体育公园";
      else if(sid =="865771054653191") sName = "坪山店";
      else if(sid =="866651067293376") sName = "鹤山芳邻店";
      else if(sid =="865771054653167") sName = "鹤山碧桂园大润发一号店";
      else if(sid =="865771054654215") sName = "台山幸福里";
    return sName;
  },
  autoSendMessage(itm,idx,flag){
    if(this.autosendLD) this.sendMsgOfLD(itm,idx,flag);
    if(this.autosendSMS) this.sendMsgOfSMS(itm,idx,flag);

    if(this.autosend) this.sendMsg(itm,idx,flag);

    this.reportPlate()

  },
  reportPlate(){
    let indexofp = 0;
    this.plateList.forEach(plate=>{
      if((indexofp != 0) || (this.msgInterval > 10))
        this.reportPlate2(plate)
      indexofp++;
    })
  },
  sendMsgOfLD(itm,idx,flag){
    if(itm.userAccount.length == 0) return;

    this.sendFlag = false

    let paras = {};

    paras.openid = itm.userAccount[idx];
    paras.title = "众敏洗车链客服在线";
    paras.tname = "温馨提醒";
    paras.remark = this.ld_msg_text;
    paras.url = this.ld_msg_url;

    let that = this;
    axios.get('/zmomc/sendTemplateMsg', {
      params: paras
    })
    .then(function (response) {
      console.log(response.data);

      if(response.data == true){
        itm.state[idx].splice(1,1, "已发")

        if(flag){
        }else{
          that.errMsg = ("发送成功");
          that.sendFlag = true;
          that.showTips();
        }
      }

    })
    .catch(function (error) {
      console.log(error);
    })
    .then(function () {
      console.log("always exec")
    });
  },
  sendMsgOfSMS(itm,idx,flag){
    this.sendMsgOfSMS_Baidu(itm,idx,flag)
  },
  sendMsgOfSMS_Tencent(itm,idx,flag){
    if(itm.mobile.length == 0) return;

    if(itm.mobile[idx] == null) return;

    if(itm.mobile[idx].length < 8) return;

    this.sendFlag = false

    let paras = {};

    paras.mobile = itm.mobile[idx];
    paras.plate = itm.plate;

    paras.posName = itm.storeName;

    // if(this.msgPayLoad.url != "") paras.posName = this.msgPayLoad.url;

    console.log(paras)

    let that = this;
    axios.get('/customer/omc/sendCareSms', {
      params: paras
    })
    .then(function (response) {
      console.log(response.data);

      if(response.data.retcode == 0){
        itm.state[idx].splice(2,1, "已发")

        if(flag){
        }else{
          that.errMsg = ("发送成功");
          that.sendFlag = true;
          that.showTips();
        }
      }

    })
    .catch(function (error) {
      console.log(error);
    })
    .then(function () {
      console.log("always exec")
    });
  },
  sendMsgOfSMS_Baidu(itm,idx,flag){
    if(itm.mobile.length == 0) return;

    if(itm.mobile[idx] == null) return;

    if(itm.mobile[idx].length < 8) return;

    this.sendFlag = false

    let paras = {};

    paras.mobile = itm.mobile[idx];
    paras.plate = itm.plate;

    paras.posName = itm.storeName;
    paras.posId = this.getStoreID( itm.storeId) + "& ";

    // if(this.msgPayLoad.url != "") paras.posName = this.msgPayLoad.url;

    console.log(paras)

    let that = this;
    axios.get('/customer/omc/sendCareSmsBaidu', {
      params: paras
    })
    .then(function (response) {
      console.log(response.data);

      if(response.data.retcode == 0){
        itm.state[idx].splice(2,1, "已发")

        if(flag){
        }else{
          that.errMsg = ("发送成功");
          that.sendFlag = true;
          that.showTips();
        }
      }

    })
    .catch(function (error) {
      console.log(error);
    })
    .then(function () {
      console.log("always exec")
    });
  },
  sendMsg(itm,idx,flag){

    if(itm.userAccount.length == 0) return;


    let paras = {};

    paras.openid = itm.userAccount[idx];
    paras.plate = itm.plate;

    paras.mobile= "未提供";
    console.log(itm.mobile)


    if((itm.mobile !=null))
      itm.mobile.forEach((m)=> {
        if(m) paras.mobile = m;
      })

    paras.service = "洗车，点这里启动";
    paras.url = itm.msgUrl;

    let that = this;
    axios.get('/zmomc/sendCCMsg', {
      params: paras
    })
    .then(function (response) {
      console.log(response.data);

      if(response.data == true){
        itm.state[idx].splice(0,1, "已发")


        if(flag){
        }else{
          that.errMsg = ("发送成功");
          that.showTips();
        }
      }

    })
    .catch(function (error) {
      console.log(error);
    })
    .finally(function(){
      console.log("fin");
    });




  },sendMsg2(itm,idx,flag){
    //this.errMsg = ("发送信息暂未开放，建设中。");
    //this.showError();

    if(itm.userAccount.length == 0) return;


    let paras = {};

    paras.openid = itm.userAccount[idx];
    paras.title = "众敏洗车链客服在线";
    paras.tname = "温馨提醒";
    paras.remark = itm.msgText;
    paras.url = itm.msgUrl;

    let that = this;
    axios.get('/zmomc/sendTemplateMsg', {
      params: paras
    })
    .then(function (response) {
      console.log(response.data);

      if(response.data == true){
        itm.state[idx].splice(0,1, "已发")


        if(flag){
        }else{
          that.errMsg = ("发送成功");
          that.showTips();
        }
      }

    })
    .catch(function (error) {
      console.log(error);
    })
    .finally(function(){
      console.log("fin");
    });




  },
  showError(){
    var $warnToast = JQ('#warnToast');
    $warnToast.fadeIn(100);
    setTimeout(function () {
        $warnToast.fadeOut(100);
    }, 5000);
  },
  showTips(){
    var $warnToast = JQ('#warnToast');
    $warnToast.fadeIn(100);
    setTimeout(function () {
        $warnToast.fadeOut(100);
    }, 1000);
  },
  getMobileByPlate(plateMsg){
    console.log("getMobileByPlate")
    this.ing=true
    this.userList=[];

    let paras = {};

    paras.plate = plateMsg.plate;

    let that = this;
    axios.get('/customer/omc/qryPhoneByPlate', {
      params: paras
    })
    .then(function (response) {
      console.log(response);
      that.userList = response.data.data

      if(that.userList.length != 0){

        that.userList.forEach(itm=>{
          plateMsg.mobile.push(itm)
          plateMsg.state.push(["","",""])

          that.autoSendMessage(plateMsg,plateMsg.mobile.length - 1,true);
        })
      }

    })
    .catch(function (error) {
      console.log(error);
    })
    .then(function () {
      console.log("always exec")
      console.log(that.userList );
    });
    this.ing=false
  },
  getPlateList(plateMsg) {
    console.log("getPlateList2")
    this.ing=true
    this.userList=[];

    let paras = {};

    paras.plate = plateMsg.plate;

    let that = this;
    axios.get('/zmomc/getUserListByComplex', {
      params: paras
    })
    .then(function (response) {
      console.log(response);
      that.userList = response.data

      console.log(that.userList.length)

      if(that.userList.length != 0){

        that.userList.forEach(itm=>{
          plateMsg.userAccount.push(itm.user_account);
          plateMsg.nickname.push(itm.nickname )
          plateMsg.mobile.push(itm.mobile)
          plateMsg.state.push(["","",""])

          that.autoSendMessage(plateMsg,plateMsg.userAccount.length - 1,true);
        })
      }else{
         that.getMobileByPlate(plateMsg);
      }

    })
    .catch(function (error) {
      console.log(error);
    })
    .then(function () {
      console.log("always exec")
      console.log(that.userList );
    });
    this.ing=false
  },
reportOne(paras){
  console.log("reportOne",paras)
  axios.get('/zmomc/plateLog', {
        params: paras
      })
      .then(function (response) {
        console.log(response);
      })
      .catch(function (error) {
        console.log(error);
      });
},
reportPlate2(item){
  // https://omc.nationaiot.com/zmomc/plateLog?plate=a&store=1&user=2&mobile=1&eflag=0&smsflag=0&ldflag=0
  console.log("reportPlate2")


    if(item.reported) return ;
    else{

      let paras = {};

      paras.plate = item.plate;
      paras.store = item.storeName;
      if(item.userAccount.length > 0){
        let idx = 0
        item.userAccount.forEach(user =>{
           paras.user = user;
           paras.eflag = item.state[idx][0] == ""?0:1;
           paras.ldflag = item.state[idx][1] == ""?0:1;
           paras.smsflag = item.state[idx][2] == ""?0:1;
           paras.mobile = item.mobile[idx++]+"";
          this.reportOne(paras);
        })
      }else if(item.mobile.length > 0){

        let idx = 0
        item.mobile.forEach(mobile =>{
           paras.user = "";
           paras.mobile = mobile;
           paras.eflag = 0;
           paras.ldflag = 0;
           paras.smsflag = item.state[idx][2] == ""?0:1;

          this.reportOne(paras);
        })
      }else{
         paras.user = "";
         paras.mobile = "";
         paras.eflag = 0;
         paras.ldflag = 0;
         paras.smsflag = 0;

        this.reportOne(paras);

      }
    }
    item.reported = true;


  }
},

}
</script>

<style scoped>

.weui-cell__bd-WU {
  width: 60px !important
}

.a_hot_touch {
  color: blue;
  font-style: italic;
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/views/plate_msg.vue